<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333; 
  font-family: 'PingFang SC', 'Microsoft Yahei', 'Helvetica Neue', 'Helvetica', 'PingFang SC', 'Tahoma', 'Hiragino Sans GB', 'Heiti SC', 'Arial', 'WenQuanYi Micro Hei', 'sans-serif';
}
</style>

